import { testimonials } from '@/mocks/siteInfo';
import { useInView } from '@/hooks/useInView';

export default function Testimonials() {
  const { ref, isInView } = useInView(0.1);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900">
            他们都在爱情岛
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            超过50,000对情侣的真实分享，98.6%满意率是我们最骄傲的成绩
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t, index) => (
            <div key={t.id} className={`bg-background-100 rounded-lg p-6 md:p-7 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${index * 150}ms` }}>
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed mb-5">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-medium text-foreground-800">{t.name}</div>
                  <div className="text-xs text-foreground-400">去了{t.destination}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}